import FormatDateToOrdinal from '../../utils/formate-date-to-ordinal';
import Loader from '../modules/loader';
import Form from '../../form_builder_2/form';

export default class FormView {
    constructor(parent, router) {
        this.router = router;
        this.formElement = parent.el.querySelector('.form_builder');
        this.scrollElement = parent.el.querySelector('.sp-container-wrapper');
        this.confirmTab = parent.el.querySelector('.sp-success-wrapper');
        this.registrationNumber = parent.el.querySelector('.vehicle-number');
        this.expiryDate = parent.el.querySelector('.service-date');
        this.loader = new Loader(parent, router);
        this.callbacks = {
            onSubmit: this.onSubmit.bind(this),
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        };
        this.form = new Form(this.formElement, this.callbacks);
    }

    onSubmit() {
        this.formElement.classList.add('hide');
        this.scrollElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.loader.show();
    }

    onSuccess(result) {
        setTimeout(() => {
            this.loader.hide();
            this.confirmTab.classList.remove('hide');
            this.populate(result);
        }, 500);
    }

    populate(result) {
        if (result && result.success) {
            if (this.registrationNumber) { this.registrationNumber.innerHTML = result.RegistrationNo; }
            if (this.expiryDate) { this.expiryDate.innerHTML = FormatDateToOrdinal.dateFormate(result.ExpiryDate); }
        }
    }

    onError() {
        setTimeout(() => {
            this.loader.hide();
            this.formElement.classList.remove('hide');
            this.form.showError();
        }, 500);
    }

    show() {
        this.router.update('vin_lookup');
        this.confirmTab.classList.add('hide');
        this.formElement.classList.remove('hide');
    }
}
